import React, { forwardRef } from 'react';
import BlockContainer from 'Components/landings/BlockContainer';
import { colors } from 'constants/colors';
import { Flex, Box } from '@igooods/ui-kit';
import { mediaMdDown, mediaSmDown } from 'theme/helpers/css';
import styled from 'styled-components';
import Title from 'Components/Typography/Title';
import { FontFamily } from 'theme';
import SearchAddress, { IGtagOptions } from 'Components/landings/LandingSearchAddress/SearchAddressBlock';
import { EnumInputTheme } from 'constants/enums';
import { GtagFrom, IBlockWithDevice } from '../types';

const Content = styled(Flex).attrs({
  pt: { xs: 10, sm: 12, md: 24, lg: 38 },
  pb: {
    xs: 14,
    sm: 20,
    md: 40,
    lg: 60,
  },
  center: true,
  column: true,
  middle: true,
})`
  width: 100%;
  max-width: 600px;
  margin-right: auto;
  margin-left: auto;

  ${mediaMdDown`
    max-width: 540px;
  `}

  ${mediaSmDown`
    max-width: none;
    align-items: flex-start;
  `}
`;

const BlockTitle = styled(Title).attrs({
  center: true,
  level: '2',
  fontFamily: FontFamily.secondFont,
  color: colors.blackRussian,
})`
  text-align: center;

  ${mediaMdDown`
    font-size: 20px;
    line-height: 30px;
  `}

  ${mediaSmDown`
    font-size: 20px;
    line-height: 30px;
    text-align: left;
    max-width: 427px;
  `}
`;

const SearchAddressContainer = styled(Box).attrs({
  mt: { xs: 7, md: 15, lg: 12 },
})`
  max-width: 580px;

  ${mediaMdDown`
    max-width: 540px;
  `}

  ${mediaSmDown`
    width: 100%;
  `}
`;

const PurchaseNow = forwardRef<HTMLDivElement, IBlockWithDevice>(({ device, ...props }, ref) => {
  const gtagOptions: IGtagOptions = {
    click_map_properties: { from: GtagFrom.WHITE_BANNER },
    click_call_to_action_properties: { from: GtagFrom.WHITE_BANNER, device },
  };

  return (
    <BlockContainer {...props} ref={ref}>
      <Content>
        <h3>
          <BlockTitle>
            Закажите продукты в&nbsp;igooods&nbsp;&mdash; мы&nbsp;выберем лучшее в&nbsp;магазине и&nbsp;доставим
            в&nbsp;день заказа
          </BlockTitle>
        </h3>
        <SearchAddressContainer>
          <SearchAddress use={EnumInputTheme.roundSecondary} gtagOptions={gtagOptions} />
        </SearchAddressContainer>
      </Content>
    </BlockContainer>
  );
});

PurchaseNow.displayName = 'PurchaseNow';

export default PurchaseNow;
